
import App from '../app';
import Events from '../events';
import * as D from '~/data-utils';

const UP = {
  target: ['#view', 'beforebegin'],
  className: 'ui-transform--up',
  id: 'switch-mode-button-top',
  baseSymbol: 'ui_transform--up',
  iconSymbol: 'ic_chevron-up',
  translationKey: 'uitransform.up'
};

const DOWN = {
  target: ['#view', 'afterend'],
  className: 'ui-transform--down',
  id: 'switch-mode-button-bottom',
  baseSymbol: 'ui_transform--down',
  iconSymbol: 'ic_chevron-down',
  translationKey: 'uitransform.down'
};

const template = ({ className, id, baseSymbol, iconSymbol }, label, resources) => `
  <div class="ui-transform-place" id=${id}>
    <div class="ui-transform ${className}">
      <svg class="ui-transform__base"><use xlink:href="${resources.get(baseSymbol)}" href="${resources.get(baseSymbol)}"></use></svg>
      <button class="ui-transform__button" type="button">
        <svg class="ui-transform__icon" ><use xlink:href="${resources.get(iconSymbol)}" href="${resources.get(iconSymbol)}"></use></svg>
        <span class="ui-transform__text">${label}</span>
      </button>
    </div>
  </div>
`;

const renderButton = (conf, label, { resources }) => {
  const html = template(conf, label, resources);
  const [select, insert] = conf.target;
  document.querySelector(select).insertAdjacentHTML(insert, html);
};

const updateButton = (conf, label) => {
  const { id } = conf;
  const button = document.querySelector(`#${id} .ui-transform__text`);
  if (button) button.textContent = label;
};

const getLabels = (currentLang, keys) => {
  const translations = App.getTranslations([currentLang]);
  return keys.map(k => translations[currentLang][k]);
};

const translationKeys = [UP, DOWN].map(x => x.translationKey);

const updateButtons = (currentLang) => {
  const [upLabel, downLabel] = getLabels(currentLang, translationKeys);
  updateButton(UP, upLabel);
  updateButton(DOWN, downLabel);
};

export const initButtons = (context) => {

  const [upLabel, downLabel] = getLabels(D.lang(), translationKeys);
  renderButton(UP, upLabel, context);
  renderButton(DOWN, downLabel, context);

  Events.addEventListener('language:change', e => {
    updateButtons(e.detail);
  });
};
